<template>
  <div class="about">
    <!-- <img class="back-btn" @click="goBack()" src="../assets/left-arrow.png" /> -->
    <h1>{{$t('i18nView.aboutTitle')}}</h1>
    <h2>{{$t('i18nView.q1')}}</h2>
    <p>{{$t('i18nView.a1')}}</p>
    <h2>{{$t('i18nView.q2')}}</h2>
    <p>{{$t('i18nView.a2')}}</p>
    <h2>{{$t('i18nView.q3')}}</h2>
    <p>{{$t('i18nView.a3')}}</p>
    <p>{{$t('i18nView.a4')}}</p>
    <!-- <img v-if="isZh" src="../assets/table.png" alt />
    <img v-else src="../assets/table-en.png" alt />-->

    <p>{{$t('i18nView.tips')}}</p>
  </div>
</template>

<script>
import tp from "tp-js-sdk";

export default {
  name: "HelloWorld",
  data() {
    return {
      isZh: true,
      usdtToCny: 7,
      showToast: false
    };
  },
  created() {
    this.isTP = !!tp.isConnected();

    if (this.isTP) {
      tp.fullScreen({
        fullScreen: 1
      });
      // tp.setMenubar({
      //   flag: 1
      // });
    }
    this.isZh = this.$i18n.locale === "zh";
  },
  methods: {
    goBack() {
      if (this.isTP) {
        tp.back();
      } else {
        if (history) {
          history.back();
        }
      }
    }
  }
};
</script>

<style scoped>
.about {
  color: #ffc0c8;
  font-size: 12px;
  padding: 26px 20px;
}

p {
  line-height: 1.5;
}

h1,
h2 {
  font-weight: normal;
}

h1 {
  text-align: center;
  color: #fff;
  font-size: 16px;
}

h2 {
  margin: 30px 0 8px;

  font-size: 16px;
  color: #fff;
}

img {
  width: 100%;
  margin-top: 20px;
}

.back-btn {
  padding: 10px;
  position: absolute;
  width: 18px;
  height: 18px;
  left: 10px;
  top: 30px;
  margin: 0;
}
</style>
